<p-tieredMenu
  #menu
  [popup]="true"
  [model]="menuItems"
  appendTo="body"
  styleClass="bfx-dashboard-menu"
></p-tieredMenu>

<button
  type="button"
  class="bfx-icon-button-secondary-subtle-sm"
  (click)="toggle(menu, $event)"
  title="Open new Panel"
  placement="bottom"
  [disabled]="!hasMenuItems"
>
  <span class="fa icon-menu"></span>
</button>
